export default "__VITE_ASSET__C14LsIQl__"